itsoftApp.createModule("scrollEffects", ["windowResize", "windowScroll", "slidersSettings"], function () {
    var module = this;

    var viewWidthEl = document.querySelector(".js-viewport");
    var desktopEl = document.querySelector(".js-desktop");

    if (viewWidthEl || desktopEl) {
        var viewport = itsoftApp.utils.getViewportSize();

        var debouncer = itsoftApp.utils.debouncer(function () {
            viewport = itsoftApp.utils.getViewportSize();
        }, 3000);

        itsoftApp.modules.windowResize.addEvent(debouncer);
    }
    // var body = document.body;

    function ScrollEffect (self, classAnimate, oldClass) {
        this._self = self;
        this._classAnimate = classAnimate;
        this._oldClass = oldClass;
        this._scrollPoint;
        this._position = "bottom";
        this._get = window.innerHeight;
        if (this._self.hasAttribute("data-position")) {
            this._position = this._self.getAttribute("data-position");
        }
        this.init();
    }

    ScrollEffect.prototype.calculateValue = function () { //cb
        if (this._position === "middle") {
            this._positionValue = window.innerHeight / 2;
        } else if (this._position === "0.75") {
            this._positionValue = window.innerHeight * 0.75;
        } else if (this._position === "top") {
            this._positionValue = 0;
        } else {
            this._positionValue = window.innerHeight;
        }

        return this._positionValue;
    };

    ScrollEffect.prototype.init = function () {
        var self = this;

        self._check = function () { //scroll
            var scrolled = pageYOffset;
            // var coeff;

            self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);

            if (scrolled + self.calculateValue() >= self._scrollPoint + scrolled) { /* NOTE: Если равен 0, элемент, скорее всего, скрыт display: none*/
                self.start();
            }
        };

        module.scrollEffectElements.push(self);

        self._check();

        itsoftApp.modules.windowScroll.addEvent(self._check);
    };

    var removeOldClass = function (obj) {
        obj._self.classList.remove(obj._oldClass);

        if (obj._classAnimate) {
            obj._self.classList.add(obj._classAnimate);
        }
        obj._oldClass = undefined;
    };

    var processing = false;

    ScrollEffect.prototype.start = function () {
        /* проверяем, дошли ли мы до нужного элемента */
        /* если да, выполняем метод start */
        if (this._oldClass && !processing) {
            processing = true;
            var sliderSettingsKey;
            var sliderSettingsObject;
            
            /* Ленивая загрузка скриптов */
            if (this._self.classList.contains("js-slider") && this._self.classList.contains("js-invisible")) {
                if (this._self.classList.contains("js-desktop") && itsoftApp.commonVars.viewWidth <= 767) {
                    processing = false;
                    return;
                }

                removeOldClass(this);
                sliderSettingsKey = this._self.getAttribute("data-slider-settings"); // получаем data-атрибут
            
                sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига
                if (sliderSettingsKey && sliderSettingsObject) {
                    itsoftApp.modules.slidersLibrary.callback(this._self, sliderSettingsObject[sliderSettingsKey]);
                } else {
                    itsoftApp.modules.slidersLibrary.callback(this._self);
                }
            }

            if (this._self.classList.contains("js-accordion") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.accordion.callback(this._self);
            }

            if (this._self.classList.contains("js-tabs-section") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.toggleTabs.callback.init(this._self);
            }

            if (this._self.classList.contains("js-image-popup") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.popups.callback.createImagePopup(this._self);
            }

            if (this._self.classList.contains("js-number-section") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.numbersAnimate.init(this._self);
            }

            if (this._self.classList.contains("js-validation") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                itsoftApp.modules.formsValidation.callback(this._self);
            }

            if (this._self.classList.contains("js-scroll-anim") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
            }

            if (this._self.classList.contains("js-scroll-trigger") && this._self.classList.contains("js-invisible")) {
                if (this._self.classList.contains("js-scroll-anchor-start")) {
                    removeOldClass(this);
                    itsoftApp.modules.scrollActions.callback(this._self);
                }

                if (this._self.classList.contains("js-scroll-text-start")) {
                    removeOldClass(this);
                    itsoftApp.modules.scrollActions.callback(this._self);
                }
            }

            if (this._self.classList.contains("js-gallery-trigger") && this._self.classList.contains("js-invisible")) {
                removeOldClass(this);
                // var i = 0;
                var fragment = document.createDocumentFragment();
                var galleryListContainer = this._self;
                var galleryElements = galleryListContainer.querySelectorAll(".js-gallery-item");
                var gallerySlider = document.querySelector(galleryElements[0].getAttribute("data-popup-selector"));
                var gallerySliderContainer = gallerySlider.querySelector(".swiper-container");
                var gallerySliderId = gallerySliderContainer.id;
                var gallerySliderWrapper = gallerySlider.querySelector(".swiper-wrapper");
                var slide = gallerySliderWrapper.querySelector(".swiper-slide");

                gallerySlider.addEventListener("click", function (evt) {
                    if (!(evt.target.closest(".gallery-slider__image"))) {
                        gallerySlider.dispatchEvent(closeEvent);
                    }
                });

                Array.prototype.forEach.call(galleryElements, function (galleryElement, index) {
                    var galleryImage = galleryElement.querySelector(".js-image-item");
                    var galleryElementSrc = galleryElement.getAttribute("href");
                    var galleryElementSrcset = galleryElement.getAttribute("data-href-retina");
                    var label = galleryElement.getAttribute.title;

                    var slideCopy = slide.cloneNode(true);
                    var gallerySliderImageContainer = slideCopy.querySelector(".gallery-slider__image-container");
                    var image = slideCopy.querySelector("img");
                    image.src = galleryElementSrc;

                    if (galleryElementSrcset) {
                        image.srcset = galleryElementSrcset;
                    }

                    if (label) {
                        var paragraphEl = document.createElement("p");
                        paragraphEl.className = "gallery-slider__label l-container";
                        paragraphEl.textContent = label;
                        gallerySliderImageContainer.appendChild(paragraphEl);
                    }

                    galleryElement.addEventListener("click", function () {
                        itsoftApp.modules.slidersLibrary.sliders[gallerySliderId].slideTo(index);
                        itsoftApp.modules.slidersLibrary.sliders[gallerySliderId].update();
                    });

                    fragment.appendChild(slideCopy);
                });

                slide.remove();
                gallerySliderWrapper.appendChild(fragment);

                sliderSettingsKey = gallerySlider.getAttribute("data-slider-settings"); // получаем data-атрибут
                sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига
                if (sliderSettingsKey && sliderSettingsObject) {
                    itsoftApp.modules.slidersLibrary.callback(gallerySlider, sliderSettingsObject[sliderSettingsKey]);
                } else {
                    itsoftApp.modules.slidersLibrary.callback(gallerySlider);
                }     
            }

            processing = false;
        }
    }


    module.ScrollEffect = ScrollEffect;
    module.scrollEffectElements = [];
});
